import { ReactNode } from 'react';
import styles from './FindingGroupSection.module.css';

interface FindingGroupSectionProps {
  title: string;
  children: ReactNode;
}

export default function FindingGroupSection({
  title,
  children,
}: FindingGroupSectionProps) {
  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <div className={styles.accentBar} />
        <span className={styles.title}>{title}</span>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
